import React, { useEffect, useState } from "react";

const SavedTabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["Summary", "Error Details", "Rule Catalogue"];
  const [productName, setProductName] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const productFromUrl = params.get("product");

    if (productFromUrl) {
      setProductName(productFromUrl);
      return;
    }

    const name = localStorage.getItem("selectedProductName");
    if (name) {
      setProductName(name);
    }
  }, []);

  return (
    <div className="tabs-container">
      <div className="tabs-title">
        {productName ? `${productName} ` : "Product Report"}
      </div>

      <div className="flex items-center gap-4">
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SavedTabs;
